import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { useNavigate } from "react-router-dom";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);
const MotionImg = motion.img;

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const ChoseOrder = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        mt: 6,
        py: 6,
        px: 4,
        color: "#fff",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(/assets/features/pos/choice.svg)`,
      }}
    >
      <Grid container spacing={8} justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <MotionTypography
            variant="body1"
            mt={4}
            mb={4}
            ml={{ xs: 0, sm: 0, lg: 2 }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Egora’s Order Management System centralizes and simplifies the
            handling of all incoming orders from various channels including POS,
            online delivery, QR code ordering, and third-party platforms. With
            real-time tracking and seamless coordination, your team can manage
            operations with speed and accuracy enhancing service and reducing
            delays.
          </MotionTypography>
          <MotionTypography
            ml={{ xs: 0, sm: 0, lg: 2 }}
            variant="h2"
            fontWeight="bold"
            gutterBottom
            color="#F68528"
            mt={2}
            sx={{ fontFamily: "Poppins" }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Why Choose Egora’s Order Management System?
          </MotionTypography>

          <MotionTypography
            variant="body1"
            mt={4}
            mb={4}
            ml={{ xs: 0, sm: 0, lg: 2 }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Managing orders across multiple touchpoints can be overwhelming.
            Egora unifies these channels into one intuitive platform, allowing
            you to process, track, and fulfill orders without juggling multiple
            systems. This results in fewer errors, faster service, and happier
            customers.
          </MotionTypography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChoseOrder;
